export const FIELD_LIMITS = {
    DEFAULT_TEXT: 200,  // Used for Name, Title, Slug, Key
    DESCRIPTION: 500,   // Used for descriptions
    REFERENCE: 100,     // Used for Customer Reference Number
    EMAIL: 100,         // Used for Email addresses
    URL: 1024,          // Used for URL fields (e.g. logo URL)
    MIN_LENGTH: 3,      // Standard minimum length for text fields
    MAX_CUSTOMER_REFERENCE_LABEL_LENGTH: 50, // Max length for custom customer reference label
    SLUG_MAX_LENGTH: 50 // Max length for slug field
};

export const DAISY_THEMES = [
  "light", "dark", "cupcake", "bumblebee", "emerald", "corporate", "synthwave",
  "retro", "cyberpunk", "valentine", "halloween", "garden", "forest", "aqua",
  "lofi", "pastel", "fantasy", "wireframe", "black", "luxury", "dracula",
  "cmyk", "autumn", "business", "acid", "lemonade", "night", "coffee",
  "winter", "dim", "nord", "sunset", "caramellatte", "abyss", "silk"
];